import { Transition } from '@headlessui/react';

import { useAppSelector } from '../../hooks';
import { AppStatus, selectAppStatus } from '../../redux';

export function AppBlocking() {
  const appStatus = useAppSelector(selectAppStatus);

  return (
    <Transition
      show={appStatus === AppStatus.BLOCKED}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed top-0 left-0 right-0 bottom-0 h-full w-full pointer-events-auto z-[49] flex flex-col cursor-wait">
        <div className="absolute top-0 left-0 right-0 bottom-0 bg-gray-900 opacity-40" />
        <div className="m-auto justify-items-center grid">
          <div className="h-[240px]">
            <div className="w-14 h-14 border-4 border-brand-primary rounded-full animate-spin border-r-transparent relative" />
          </div>
        </div>
      </div>
    </Transition>
  );
}

export default AppBlocking;
